import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';

Vue.use(Router);
Vue.use(Meta);

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: '/',
      redirect: { name: 'dashboard' },
    },
    {
      path: '/:agency(\\d+)',
      component: require('./views/EmptyRouterView.vue').default,
      children: [
        {
          path: '',
          component: require('./views/Wrapper.vue').default,
          children: [
            {
              path: '',
              redirect: { name: 'dashboard' },
            },
            {
              path: 'events',
              component: require('./views/Events.vue').default,
              name: 'dashboard',
            },
            {
              path: 'orders',
              component: require('./views/Orders.vue').default,
              name: 'orders',
            },
            {
              path: 'orders/:id',
              name: 'order',
              component: () => import(/* webpackChunkName: "order" */ './views/order/Order.vue'),
            },
          ],
        },
        {
          path: 'orders/:id/receipt',
          name: 'receipt',
          component: () => import(/* webpackChunkName: "order" */ './views/order/Receipt.vue'),
        },
        {
          path: 'events/:id',
          component: () => import(/* webpackChunkName: "event" */ './views/event/Wrapper.vue'),
          children: [
            {
              path: '',
              name: 'event',
              redirect: { name: 'event.tickets' },
            },
            {
              path: 'tickets',
              name: 'event.tickets',
              component: () => import(/* webpackChunkName: "event" */ './views/event/Tickets.vue'),
            },
            {
              path: 'information',
              name: 'event.information',
              component: () =>
                import(/* webpackChunkName: "event" */ './views/event/Information.vue'),
            },
            {
              path: 'location',
              name: 'event.location',
              component: () => import(/* webpackChunkName: "event" */ './views/event/Location.vue'),
            },
            {
              path: 'organizer',
              name: 'event.organizer',
              component: () =>
                import(/* webpackChunkName: "event" */ './views/event/Organizer.vue'),
            },
          ],
        },
        {
          path: 'account',
          component: () => import(/* webpackChunkName: "account" */ './views/account/Wrapper.vue'),
          children: [
            {
              path: '',
              redirect: { name: 'account.details' },
              name: 'account',
            },
            {
              path: 'details',
              name: 'account.details',
              component: () =>
                import(/* webpackChunkName: "account" */ './views/account/Details.vue'),
            },
            {
              path: 'contact',
              name: 'account.contact',
              component: () =>
                import(/* webpackChunkName: "account" */ './views/account/Contact.vue'),
            },
          ],
        },

        {
          path: 'accounting',
          component: () =>
            import(/* webpackChunkName: "account" */ './views/accounting/Wrapper.vue'),
          children: [
            {
              path: '',
              redirect: { name: 'accounting.report' },
              name: 'accounting',
            },
            {
              path: 'report',
              name: 'accounting.report',
              component: () =>
                import(/* webpackChunkName: "accounting" */ './views/accounting/Report.vue'),
            },
            {
              path: 'settlement',
              name: 'accounting.settlement',
              component: () =>
                import(/* webpackChunkName: "accounting" */ './views/accounting/Settlement.vue'),
            },
            {
              path: 'invoice',
              name: 'accounting.invoice',
              component: () =>
                import(/* webpackChunkName: "accounting" */ './views/accounting/Invoice.vue'),
            },
          ],
        },
      ],
    },

    {
      path: '/*',
      name: '404',
      component: require('./views/404.vue').default,
    },
  ],
});

export default router;
